legend_transit_handler = {

    properties: {
        title: 'Map Legend'
    },

    onLoad: function(){
        var self = this;
        $('#content-root, #map').addClass('noswipe');
    },

    events: function() {
        var self = this;
        self.onLoad();

        legend_handler.events();


    }
}